export default {
  gridSize: 1,
  cutPadding: {
    horizontal: 10,
    vertical: 5
  },
  cutCornerRadius: 10,
  initialSeparation: 50,
}